import { useEffect, useState } from 'react';
import MobileSignal from '../../../../Assets/StorefrontIcons/MobileSignal.svg';
import Wifi from '../../../../Assets/StorefrontIcons/Wifi.svg';
import Battery from '../../../../Assets/StorefrontIcons/Battery.svg';
import { useSelector } from 'react-redux';
import SearchBox from './SearchBox';
import SectionButtons from './SectionButtons';
import MobileBanner from './MobileBanner';
import CategorySection from './StoreSections/CategorySection';
import CarouselBanner from './StoreSections/CarouselBanner/CarouselBanner';
import CategoryCollectionList from './StoreSections/CategoryCollectionList/CategoryCollectionList';
import OfferDisplay from './StoreSections/OfferDisplay/OfferDisplay';
import AboutOne from './AboutSections/AboutOne';
import AboutTwo from './AboutSections/AboutTwo';
import AboutThree from './AboutSections/AboutThree';
import FeaturesTwo from './AboutSections/FeaturesTwo';
import FeaturesOne from './AboutSections/FeaturesOne';
import CustomCollectionList from './StoreSections/CustomCollectionList/CustomCollectionList';
import SingleBanner from './StoreSections/SingleBanner';

const OPTIONS = { loop: true, duration: 60, }

function MobileScreen() {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);
    const pageType = useSelector((state) => state.storefront.pageType);
    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const [screenSize, setScreenSize] = useState(0);
    const [spacing, setSpacing] = useState(0);

    const [gap, setGap] = useState(0);

    const [paddingX, setPaddingX] = useState(0);
    const [paddingY, setPaddingY] = useState(0);

    const [timeSize, setTimeSize] = useState(0);
    const [timeLineHeight, setTimeLineHeight] = useState(0);

    const [signalWidth, setSignalWidth] = useState(0);
    const [wifiWidth, setWifiWidth] = useState(0);
    const [batteryWidth, setBatteryWidth] = useState(0);

    useEffect(() => {
        setScreenSize((zoomSize/100)*375);
        setSpacing((zoomSize/100)*32);

        setGap((zoomSize/100)*16);
        setPaddingX((zoomSize/100)*16);
        setPaddingY((zoomSize/100)*14);

        setTimeSize((zoomSize/100)*17);
        setTimeLineHeight((zoomSize/100)*22);

        setSignalWidth((zoomSize/100)*18);
        setWifiWidth((zoomSize/100)*17);
        setBatteryWidth((zoomSize/100)*28);
    }, [zoomSize]);

    return (
        <div style={{ width: `${screenSize}px` }} className="font-rubik mx-auto mt-4 h-[calc(100%-32px)] bg-[#FFE2E245] relative overflow-y-scroll no-scrollbar">
            <div style={{ paddingLeft: `${paddingX}px`, paddingRight: `${paddingX}px`, paddingTop: `${paddingY}px`, paddingBottom: `${paddingY}px` }} className="w-full sticky z-10 top-0 left-0 flex items-center justify-between">
                <p style={{ fontSize: `${timeSize}px`, lineHeight: `${timeLineHeight}px` }} className="font-semibold text-[#FFFFFF]">9:41</p>

                <div style={{ gap: `${gap}px` }} className="flex items-center">
                    <img style={{ width: `${signalWidth}px` }} className='h-auto' src={MobileSignal} alt="" />

                    <img style={{ width: `${wifiWidth}px` }} className='h-auto' src={Wifi} alt="" />

                    <img style={{ width: `${batteryWidth}px` }} className='h-auto' src={Battery} alt="" />
                </div>
            </div>

            <MobileBanner />

            <div style={{ paddingTop: `${spacing}px`, paddingBottom: `${spacing}px` }} className="w-full"></div>

            <div style={{ gap: `${gap}px` }} className="flex flex-col">
                <SectionButtons />

                <SearchBox />

                {
                    pageType === 'STORE' && 
                    <>
                        {versionStack[versionIndex]?.versionData?.map(item => {
                            if(item.item.typeData === 'CATEGORY') {
                                return (
                                    <CategorySection 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'SINGLE_BANNER') {
                                return (
                                    <SingleBanner 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'CAROUSEL_BANNER') {
                                return (
                                    <CarouselBanner 
                                        item={item} 
                                        key={item.id} 
                                        options={OPTIONS} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'CATEGORY_COLLECTION_LIST') {
                                return (
                                    <CategoryCollectionList 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'CUSTOM_COLLECTION_LIST') {
                                return (
                                    <CustomCollectionList 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'OFFER_DISPLAY') {
                                return (
                                    <OfferDisplay 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            else return null;
                        })}
                    </>
                }

                {
                    pageType === 'ABOUT' && 
                    <>
                        {versionStack[versionIndex]?.storeAbout.map(item => {
                            if(item.item.TypeData === 'ABOUT1') {
                                return (
                                    <AboutOne 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'ABOUT2') {
                                return (
                                    <AboutTwo 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'ABOUT3') {
                                return (
                                    <AboutThree 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'FEATURE1') {
                                return (
                                    <FeaturesOne 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'FEATURE2') {
                                return (
                                    <FeaturesTwo 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            else return null;
                        })}
                    </>
                }
            </div>

            <div className="w-full py-12"></div>
        </div>
    );
}

export default MobileScreen;
